module.exports = __webpack_public_path__ + "media/images/icons/flags/FO-6904bb2879c90802b79323dde25272f1.svg";